import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const CbseDisclosure = () => {
  useEffect(() => {
    document.title = "CBSE Disclosure -   Mary Matha Cmi  Academy";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> CBSE Mandatory Disclosure </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> CBSE Mandatory Disclosure </h1>
            </div>
          </div>
          <div className="row">

            <div class="accordion mb-3" id="mandatoryDisclosure">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#generalInformation"
                    aria-expanded="true">
                    A: GENERAL INFORMATION
                  </button>
                </h2>
                <div id="generalInformation"
                  class="accordion-collapse collapse show"
                  data-bs-parent="#mandatoryDisclosure">
                  <div class="accordion-body p-0">
                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="10%" class="text-center">SL. NO.</th>
                            <th width="50%" class="text-center">INFORMATION</th>
                            <th width="40%" class="text-center">DETAILS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>NAME OF THE SCHOOL</td>
                            <td>MARY MATHA CMI ACADEMY</td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>NAME OF THE TRUST</td>
                            <td>Mary Matha Educational and Charitable Society</td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>STATE GOVT. NOC NUMBER &amp; DATE</td>
                            <td>K.Dis. No.4809/D1/2025 Dt. 24.06.2025</td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>STATE RECOGNITION NUMBER &amp; VALIDITY</td>
                            <td>001-08-S-0021-0428 (Valid up to 09.04.2028)</td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>UDISE NUMBER</td>
                            <td>33254100246</td>
                          </tr>

                          <tr>
                            <td>6</td>
                            <td>CBSE AFFILIATION NUMBER</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>7</td>
                            <td>SCHOOL CODE</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>8</td>
                            <td>AFFILIATION PERIOD</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>9</td>
                            <td>CATEGORY</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>10</td>
                            <td>NAME OF THE PRINCIPAL</td>
                            <td>Mrs. M. RAJAM</td>
                          </tr>

                          <tr>
                            <td>11</td>
                            <td>EDUCATIONAL QUALIFICATION</td>
                            <td>M.A., B.Ed.</td>
                          </tr>

                          <tr>
                            <td>12</td>
                            <td>SCHOOL EMAIL ID</td>
                            <td>
                              <a href="mailto:mmcmiacademy@gmail.com">
                                mmcmiacademy@gmail.com
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td>13</td>
                            <td>SCHOOL WEBSITE</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org" target="_blank">
                                www.marymathacmiacademy.org
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td>14</td>
                            <td>COMPLETE ADDRESS WITH PIN CODE</td>
                            <td>
                              D.No.224/B, Perumalkoilpatti, Devadanapatti,
                              Periyakulam Taluk, Theni District – 625 602
                            </td>
                          </tr>

                          <tr>
                            <td>15</td>
                            <td>CONTACT DETAILS (LAND LINE / MOBILE)</td>
                            <td>
                              <a href="tel:+918056851655">+91 80568 51655</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#documents">
                    B: DOCUMENTS AND INFORMATION
                  </button>
                </h2>
                <div id="documents"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">
                  <div class="accordion-body p-0">
                    <div class="table-responsive maintable">
                      <div class="table-responsive maintable">
                        <table class="table">
                          <thead>
                            <tr>
                              <th width="10%" class="text-center">SL. NO.</th>
                              <th width="60%" class="text-center">DOCUMENTS / CERTIFICATES</th>
                              <th width="30%" class="text-center">LINKS OF UPLOADED DOCUMENTS</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>CBSE AFFILIATION GRANT LETTER</td>
                              <td>
                                <a href="#">-</a>
                              </td>
                            </tr>

                            <tr>
                              <td>2</td>
                              <td>REGISTERED SOCIETY CERTIFICATE</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/soc-reg.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>3</td>
                              <td>NO OBJECTION CERTIFICATE (NOC)</td>
                              <td>
                                <a href="https://marymathacmiacademy.org/pdf/noc.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>4</td>
                              <td>CERTIFICATE OF RECOGNITION</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/RECOGNITION.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>5</td>
                              <td>BUILDING SAFETY CERTIFICATE</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/BUILDING.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>6</td>
                              <td>FIRE SAFETY CERTIFICATE</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/FIRESAFETY.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>7</td>
                              <td>SELF CERTIFICATION PROFORMA</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/SELF-CERTIFICATION.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>

                            <tr>
                              <td>8</td>
                              <td>WATER AND SANITATION CERTIFICATE &amp; WATER SAMPLE TEST REPORT</td>
                              <td>
                                <a href="https://www.marymathacmiacademy.org/pdf/SANITATION.pdf" target="_blank">VIEW</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#academic">
                    C: RESULT AND ACADEMICS
                  </button>
                </h2>

                <div id="academic"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">

                  <div class="accordion-body p-0">

                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="10%" class="text-center">SL. NO.</th>
                            <th width="60%" class="text-center">DOCUMENTS / CERTIFICATES</th>
                            <th width="30%" class="text-center">LINKS OF UPLOADED DOCUMENTS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>FEE STRUCTURE</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/fee-structure.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>ANNUAL ACADEMIC CALENDAR</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/aca-calender.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/management.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>4</td>
                            <td>LIST OF PARENT-TEACHER ASSOCIATION (PTA)</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/pta.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>5</td>
                            <td>LAST THREE YEAR RESULTS OF THE BOARD EXAMINATION AS PER APPLICABILITY</td>
                            <td>
                              <a href="#" >-</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#class10">
                    RESULTS CLASS X
                  </button>
                </h2>

                <div id="class10"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">

                  <div class="accordion-body p-0">

                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="10%" class="text-center">SL. NO.</th>
                            <th width="20%" class="text-center">YEAR</th>
                            <th width="20%" class="text-center">NO. OF REGISTERED STUDENTS</th>
                            <th width="20%" class="text-center">NO. OF STUDENTS PASSED</th>
                            <th width="15%" class="text-center">PASS PERCENTAGE</th>
                            <th width="15%" class="text-center">REMARKS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFive">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#class12">
                    RESULTS CLASS XII
                  </button>
                </h2>

                <div id="class12"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">

                  <div class="accordion-body p-0">

                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="10%" class="text-center">SL. NO.</th>
                            <th width="20%" class="text-center">YEAR</th>
                            <th width="20%" class="text-center">NO. OF REGISTERED STUDENTS</th>
                            <th width="20%" class="text-center">NO. OF STUDENTS PASSED</th>
                            <th width="15%" class="text-center">PASS PERCENTAGE</th>
                            <th width="15%" class="text-center">REMARKS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>

              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#staff">
                    D: STAFF (TEACHING)
                  </button>
                </h2>

                <div id="staff"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">

                  <div class="accordion-body p-0">
                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="10%" class="text-center">SL. NO.</th>
                            <th width="35%" class="text-center">INFORMATION</th>
                            <th width="20%" class="text-center">NUMBER / STRENGTH</th>
                            <th width="35%" class="text-center">NAME &amp; QUALIFICATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>PRINCIPAL</td>
                            <td>01</td>
                            <td>M. Rajam, M.A., B.Ed.</td>
                          </tr>

                          <tr>
                            <td>2</td>
                            <td>VICE PRINCIPAL</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>3</td>
                            <td>HEADMASTER</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td rowSpan={5}>4</td>
                            <td>TOTAL NO. OF TEACHERS </td>
                            <td>-</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/STAFF-DETAILS.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>PGT</td>
                            <td>--</td>
                            <td>
                              <a href="#" target="_blank">-</a>
                            </td>
                          </tr>

                          <tr>
                            <td>TGT</td>
                            <td>5</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/STAFF-TGT.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>PRT</td>
                            <td>8</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/STAFF-PRT.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>

                          <tr>
                            <td>NTT</td>
                            <td>4</td>
                            <td>
                              <a href="https://www.marymathacmiacademy.org/pdf/STAFF-NTT.pdf" target="_blank">VIEW</a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>TEACHER – SECTION RATIO</td>
                            <td>1.5 : 1</td>
                            <td>--</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>DETAILS OF SPECIAL EDUCATOR</td>
                            <td>01</td>
                            <td>Fr. Prince Joy, Spl. B.Ed.</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>DETAILS OF COUNSELLOR &amp; WELLNESS TEACHER</td>
                            <td>01</td>
                            <td>Ms. Sahaya Amali L., M.Sc. (Psychology)</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>

              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSeven">
                  <button class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#infrastructure">
                    E: INFRASTRUCTURE
                  </button>
                </h2>
                <div id="infrastructure"
                  class="accordion-collapse collapse"
                  data-bs-parent="#mandatoryDisclosure">
                  <div class="accordion-body p-0">
                    <div class="table-responsive maintable">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="50%" class="text-center">INFORMATION</th>
                            <th width="20%" class="text-center">NUMBER</th>
                            <th width="15%" class="text-center">AREA (SQ. FT.)</th>
                            <th width="15%" class="text-center">AREA (SQ. MT.)</th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr>
                            <td>TOTAL LAND AREA </td>
                            <td>Single contiguous plot</td>
                            <td>03 Acres 32.5 Cents</td>
                            <td>13450</td>
                          </tr>
                          <tr>
                            <td>PLAY GROUND AREA</td>
                            <td>01</td>
                            <td>43,550</td>
                            <td>4,046</td>
                          </tr>

                          <tr>
                            <td>CLASSROOMS</td>
                            <td>18</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>LIBRARY</td>
                            <td>01</td>
                            <td>1,240</td>
                            <td>115</td>
                          </tr>

                          <tr>
                            <td>COMPOSITE SCIENCE LAB</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>COMPUTER LAB</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>MATH LAB</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>MULTI-PURPOSE HALL</td>
                            <td>01</td>
                            <td>1,513</td>
                            <td>140.5</td>
                          </tr>

                          <tr>
                            <td>INDOOR GAMES / PET ROOM</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>STAFF ROOM</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>SPECIAL EDUCATOR ROOM</td>
                            <td>01</td>
                            <td>604</td>
                            <td>56</td>
                          </tr>

                          <tr>
                            <td>COUNSELLOR ROOM</td>
                            <td>01</td>
                            <td>130</td>
                            <td>12</td>
                          </tr>

                          <tr>
                            <td>WELLNESS ROOM</td>
                            <td>01</td>
                            <td>130</td>
                            <td>12</td>
                          </tr>

                          <tr>
                            <td>DRINKING WATER TAPS</td>
                            <td>32</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>HAND WASH</td>
                            <td>32</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>TOILETS (GIRLS)</td>
                            <td>27</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>TOILETS (BOYS)</td>
                            <td>27</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>CWSN TOILETS (GIRLS)</td>
                            <td>03</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>CWSN TOILETS (BOYS)</td>
                            <td>03</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>STAFF TOILET (FEMALE)</td>
                            <td>03</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>STAFF TOILET (MALE)</td>
                            <td>03</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>
                            <td>URINALS WITH PARTITION (GIRLS)</td>
                            <td>36</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>

                          <tr>

                            <td>URINALS WITH PARTITION (BOYS)</td>
                            <td>36</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CbseDisclosure;
